import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IntegrationComponent } from './integration/integration.component';
import { LoginComponent } from './login/login.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { S3InfoResolver } from './resolvers/s3.resolver';
import { siteRedirectGuard } from './guards/site-redirect.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/notfound',
    pathMatch: 'full'
  },
  {
    path: 'notfound',
    component: NotFoundComponent
  },
  {
    path: ':site/login',
    component: LoginComponent
  },
  {
    path: ":site",
    component: IntegrationComponent,
    canActivate: [siteRedirectGuard],
    resolve:{
      resolved : S3InfoResolver
    }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
